import { ReactNode } from "react";
import { useFeatureFlag } from "./useFeatureFlag";

type FeatureProps = {
  flag: string;
  children: ReactNode;
  fallback?: ReactNode;
};

const Feature = ({ flag, children, fallback = null }: FeatureProps) => {
  const enabled = useFeatureFlag(flag);

  return <>{enabled ? children : fallback}</>;
};

export default Feature;
